import * as React from 'react';
import { useParams } from 'react-router-dom';
import { LogOut, Plus } from 'lucide-react';
import Button from '../../../components/Button/Button';
import { Switch } from '../../../components/ui/switch';
import IntentsAutoComplete from '../../../components/IntentsAutoComplete/IntentsAutoComplete';
import Intent from '../../../types/BotBuilder/Intent';

interface BotBuilderHeaderProps {
  intent: Intent;
  embedIsReady: boolean;
  testBotVisible: boolean;
  onToggleTestBot: () => void;
  onExit: () => void;
  onNavigateToIntent: (intentId: number) => void;
  onAddNewQuestion: () => void;
  isNewIntent: boolean;
}

function BotBuilderHeader({
  intent,
  embedIsReady,
  testBotVisible,
  onToggleTestBot,
  onExit,
  onNavigateToIntent,
  onAddNewQuestion,
  isNewIntent
}: Readonly<BotBuilderHeaderProps>): React.ReactElement {
  const { chatbotId } = useParams();

  return (
    <header className='flex h-20 w-full items-center justify-between gap-4 bg-brand-dark px-4'>
      <h1 className='min-w-0 truncate text-2xl font-normal text-white'>
        Question Builder: {intent.name || 'New Question'}
      </h1>
      <div className='flex flex-shrink-0 items-center gap-4'>
        {embedIsReady && (
          <div className='flex cursor-pointer items-center gap-2 text-sm text-white'>
            <span id='test-chatbot-label'>Show test chatbot</span>
            <Switch
              checked={testBotVisible}
              onCheckedChange={onToggleTestBot}
              aria-labelledby='test-chatbot-label'
            />
          </div>
        )}
        <Button
          icon={<Plus size={16} />}
          size='lg'
          onClick={onAddNewQuestion}
          disabled={isNewIntent}
        >
          Add FAQ
        </Button>
        <IntentsAutoComplete
          intentId={intent.id}
          intentName={intent.name}
          showClearButton={false}
          onNavigate={onNavigateToIntent}
          className='w-80'
          triggerClassName='h-11 px-3'
          chatbotId={Number(chatbotId)}
        />
        <Button icon={<LogOut size={16} />} size='lg' onClick={onExit}>
          Exit
        </Button>
      </div>
    </header>
  );
}

export default BotBuilderHeader;
